export default {
  // Privacy Realms
  async getPrivacyRealms() {
    const response = await this.request('/privacy-realms');
    return response.profiles || response.realms || [];
  },

  // Share ONE node into one or more of the caller's realms (additive + idempotent).
  // Server side of the app-driven "Share to realm" consent flow. Returns
  // { node_id, results: [{ realm_id, realm_name, status }] }.
  async shareNodeToRealms(nodeId, realmIds, appId = null, groupId = null) {
    return this.request('/privacy-realms/share-node', {
      method: 'POST',
      body: { node_id: nodeId, realm_ids: realmIds, app_id: appId, group_id: groupId },
    });
  },

  // Share ONE node with a group the caller is in. Server side of the app-driven
  // "Share with a group" consent flow — the group's members can then read exactly
  // that node. Additive: the note joins the `-> <group>` realm on the member -> group
  // contract, so it never narrows what is already shared.
  async shareNodeWithGroup(nodeId, groupId, access = 'view') {
    return this.request(`/nodes/${nodeId}/share`, {
      method: 'POST',
      body: { entity_id: groupId, entity_type: 'group', access },
    });
  },

  async getPrivacyRealm(realmId) {
    return this.request(`/privacy-realms/${realmId}`);
  },

  // Authorizations
  async revokeAuthorization(authId) {
    return this.request(`/authorizations/${authId}`, {
      method: 'DELETE',
    });
  },

  async approveAuthorizationV2(data) {
    return this.request('/authorize/approve', {
      method: 'POST',
      body: data,
    });
  },

  /**
   * Answer a runtime ask — an app widening a grant it already holds.
   *
   * `{ client_id, request_id, decision: 'grant' | 'deny' }`. Additive on a
   * grant: consent only ever widens, by exactly the batch's pending items. A
   * deny is RECORDED, not dropped — the app can read that answer and stop
   * asking, where an unanswered request reads as "not yet".
   */
  async expandAuthorization(data) {
    return this.request('/authorize/expand', {
      method: 'POST',
      body: data,
    });
  },

  /**
   * Assign a realm to an app's sub-entity (an agent).
   *
   * A separate endpoint because it is a separate act: `/authorize/approve`
   * grants the APP and ignores `sub_entity_key` entirely, so routing an agent
   * through it attaches the realm to the parent and leaves the agent with
   * nothing — silently.
   */
  async approveSubEntityRealm(data) {
    return this.request('/authorize/sub-entity', {
      method: 'POST',
      body: data,
    });
  },

  // Exposure Profiles — direct CRUD
  async pauseExposureProfile(epId) {
    return this.request(`/exposure-profiles/${epId}/pause`, { method: 'POST' });
  },

  async resumeExposureProfile(epId) {
    return this.request(`/exposure-profiles/${epId}/resume`, { method: 'POST' });
  },
};
